// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__pq0jg","title":"styles_title__8mBxq","error":"styles_error__NPPso","itinerarySection":"styles_itinerarySection__Xs-rC"};